import { render, staticRenderFns } from "./CompanySelectorObj.vue?vue&type=template&id=0622300c&scoped=true"
import script from "./CompanySelectorObj.vue?vue&type=script&lang=js"
export * from "./CompanySelectorObj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622300c",
  null
  
)

export default component.exports